import { ProjectListPageSearchResults, CompanyListPageSearchResults, PaginationTextTranslation } from './../typings/backend-models';
import paginate, { Pagination } from '../function/paginate';

interface PaginatableSearchResults {
    paginationTranslation: PaginationTextTranslation;
    pageSearchHitsCount: number;
}

const cardsPagination = (searchData: PaginatableSearchResults, onPageChange: (pagination: Pagination) => void) => {
    const { paginationTranslation, pageSearchHitsCount } = searchData;
    const { forNext, forOf, forPrevious } = paginationTranslation;

    const paginationEl = document.querySelector('.pagination-dynamic');
    const { numberOfItemsInList } = (paginationEl as HTMLElement).dataset;

    const pageSize = Number(numberOfItemsInList);

    let pagination = paginate({ totalItems: pageSearchHitsCount, pageSize });

    const createPagination = () => {
        const { pages, currentPage, totalPages } = pagination;
        const paginationEl = document.querySelector('.pagination-dynamic');
        const paginationWrapperEl = paginationEl.querySelector('.pagination__wrapper');
        if (pageSearchHitsCount === 0 || !pages.length) {
            paginationWrapperEl.innerHTML = '';
            return;
        }
        if (pages.length === 1) {
            onPageChange(pagination);
            return;
        }

        const paginationMobileEl = document.createElement('p');

        paginationMobileEl.classList.add('pagination__mobile');
        paginationMobileEl.innerHTML = `
            <span class="pagination__mobile__current">${currentPage}</span>
            ${forOf}
            <span class="pagination__mobile__total">${totalPages}</span>
        `;

        const paginationListEl = document.createElement('ul');
        paginationListEl.classList.add('pagination__list');

        const paginationItems: Element[] = [];
        pages.forEach((num) => {
            const isActive = num === currentPage;
            const item = createPaginationItem(num, isActive);
            paginationItems.push(item);
        });

        paginationWrapperEl.append(paginationMobileEl, paginationListEl);

        const previousButton = `
            <li class="pagination__item pagination__item--previous">
                <button class="pagination__previous" rel="prev">
                    <span class="pagination__previous__icon">
                        <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                            aria-hidden="true" focusable="false" fill="currentColor">
                            <polygon
                                points="29.83 5.73 27 8.55 40.01 21.56 40.01 22 4.02 22 4.02 26 40.01 26 40.01 26.44 26.98 39.45 29.81 42.28 44.01 28.1 44.01 19.91 29.83 5.73">
                            </polygon>
                        </svg>
                    </span>
                    <span class="pagination__previous__text">${forPrevious}</span>
                </button>
            </li>
        `;

        const nextButton = `
            <li class="pagination__item pagination__item--next">
                <button class="pagination__next" rel="next">
                    <span class="pagination__next__text">${forNext}</span>
                    <span class="pagination__next__icon">
                        <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                            fill="currentColor" aria-hidden="true" focusable="false">
                            <polygon
                                points="29.83 5.73 27 8.55 40.01 21.56 40.01 22 4.02 22 4.02 26 40.01 26 40.01 26.44 26.98 39.45 29.81 42.28 44.01 28.1 44.01 19.91 29.83 5.73">
                            </polygon>
                        </svg>
                    </span>
                </button>
            </li>
        `;
        if (currentPage > 1) {
            paginationListEl.insertAdjacentHTML('afterbegin', previousButton);
        }
        paginationItems.forEach((item) => paginationListEl.append(item));
        if (currentPage < totalPages) {
            paginationListEl.insertAdjacentHTML('beforeend', nextButton);
        }

        const buttonPreviousEl = document.querySelector('button.pagination__previous');
        const buttonNextEl = document.querySelector('button.pagination__next');

        buttonPreviousEl?.addEventListener('click', function () {
            const { currentPage } = pagination;
            setCurrentPage(currentPage - 1);
        });
        buttonNextEl?.addEventListener('click', function () {
            const { currentPage } = pagination;
            setCurrentPage(currentPage + 1);
        });

        onPageChange(pagination);
    };

    const setCurrentPage = (num: number) => {
        const { totalPages } = pagination;

        if (num < 1 || num > totalPages || num === pagination.currentPage) return;

        pagination = paginate({ totalItems: pageSearchHitsCount, pageSize, currentPage: num });

        // Re-render the full pagination to update the visible page buttons
        const paginationEl = document.querySelector('.pagination-dynamic');
        const paginationWrapperEl = paginationEl.querySelector('.pagination__wrapper');
        paginationWrapperEl.innerHTML = '';
        createPagination();
    };

    const createPaginationItem = (num: number, isActive: Boolean): Element => {
        const item = document.createElement('li');
        item.classList.add('pagination__item');
        item.setAttribute('data-page-number', num.toString());

        item.addEventListener('click', function (e) {
            setCurrentPage(num);
        });

        if (isActive) {
            const link = document.createElement('span');
            link.classList.add('pagination__link');
            link.textContent = num.toString();

            item.append(link);
            item.classList.add('pagination__item--current');

            return item;
        } else {
            const link = document.createElement('span');
            link.classList.add('pagination__link');
            link.textContent = num.toString();

            item.append(link);

            return item;
        }
    };

    createPagination();
};

export default cardsPagination;
